<snt-button
  [icon]="icon"
  [title]="title"
  [type]="type"
  [disabled]="disabled"
  [loading]="loading"
  [small]="small"
  [trackEvent]="trackEvent"
  [ngClass]="{ 'flex-1': flex() }"
  (onClick)="click()"
></snt-button>
